import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import SowjanyaStudios from "../assets/Sowjanya_studios.png";
import MayuInfra from "../assets/mayuinfra.png";
import MasterAbroad from "../assets/masterabroad.png";
import SowjanyaStudios2 from "../assets/sowjanyastudips.png";

import "../styles/Portfolio.css";

function Portfolio() {
  const projects = [
    { id: 1, image: SowjanyaStudios },
    { id: 2, image: MayuInfra },
    { id: 3, image: MasterAbroad },
    { id: 4, image: SowjanyaStudios2 },
  ];

  return (
    <section className="portfolio-section">
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        loop={true}
        loopedSlides={projects.length}
        slidesPerGroup={1}
        centeredSlides={false}
        grabCursor={true}
        allowTouchMove={true}
        speed={800}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        breakpoints={{
          0: {
            slidesPerView: 1.2,
            spaceBetween: 12,
          },

          768: {
            slidesPerView: 2.2,
            spaceBetween: 16,
          },

          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        }}
      >
        {projects.map((project) => (
          <SwiperSlide key={project.id}>
            <div className="card">
              <img
                src={project.image}
                alt={`Project ${project.id}`}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default Portfolio;